import React from "react";
import { toJS } from "mobx";
import { Form } from "@modules/formx-react";
import { Grid } from "@material-ui/core";
import { ErrorBoundary } from "@components/error-boundary";
import { Spinner } from "@components";
import { Date as Datex, Text, Select } from "@components/formx";
import { Option } from "@common/Select";
import { store as rootStore } from "@store";
import { ReminderFormData, ReminderStore } from "./ReminderStore";

export const initialValues: ReminderFormData = {
  date: new Date(),
  text: ""
};

type Props = {
  store: ReminderStore;
  teamsDisabled: boolean;
};

export function ReminderForm(props: Props) {
  const { store } = props;

  if (store.isLoading) {
    return <Spinner />;
  }

  const getTeamsOptions = (): Option[] => {
    const teams = toJS(rootStore().cache.teams).map((x) => ({
      label: x.Name,
      value: x.TodoGroup
    }));

    return teams.filter((x) => x.value !== "Staffing");
  };

  return (
    <ErrorBoundary>
      <Form store={store.form} allowUpdates>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Datex
              name="date"
              label="Date"
              DatePickerProps={{
                showTimeSelect: true,
                shouldCloseOnSelect: true,
                popperClassName: "some-custom-class",
                popperPlacement: "top-end",
                popperModifiers: [
                  {
                    options: {
                      offset: {
                        enabled: false,
                        offset: "5px, 10px"
                      },
                      preventOverflow: {
                        enabled: false,
                        escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                        boundariesElement: "viewport"
                      }
                    }
                  }
                ]
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Text
              name="text"
              label="Text"
              TextFieldProps={{
                fullWidth: true,
                multiline: true
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Select
              fullWidth
              name="assignedTeam"
              label="Team"
              options={getTeamsOptions()}
            />
          </Grid>
        </Grid>
      </Form>
    </ErrorBoundary>
  );
}
